import { render, staticRenderFns } from "./ConfirmationMessageEl.vue?vue&type=template&id=64e7e479&scoped=true&"
import script from "./ConfirmationMessageEl.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationMessageEl.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationMessageEl.vue?vue&type=style&index=0&id=64e7e479&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e7e479",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
